import React, { useEffect, useState, useRef } from "react";

import * as echarts from 'echarts';
import { formatNum } from "@/pages/intelligence/utils/commonUtils";
import ChartBubble from "@/pages/intelligence/components/ChartBubble";
import { useIntl } from 'umi';


export default function NetChart(props: any) {
  const {
    xAxis,
    mobileData,
    pcData,
    consoleData,
    chartStyle = {
      height: '280px',
      width: '100%',
    }
  } = props;

  const ref = useRef<HTMLDivElement>(null);
  const { formatMessage } = useIntl();
  const lineColorSet = ['#5086F3', '#5EC8F1', '#69D19C']

  const getOptions = () => ({
    legend: {
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      bottom: 0,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
      },
      itemGap: 20,
    },

    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0)',
      padding: 0,
      borderWidth: 0,
      axisPointer: {
        type: 'line',
      },
      formatter(params: any[]) {
        return ChartBubble({
          data: params,
          secondTitleRight: formatMessage({id: 'dbi_revenue_$'}),
          // titleNow: `${formatMessage({ id: 'dbi-sm-revenue' })}($)`,
          chartType: 'line',
          ifNoBarImg: true,
        })
      },
    },
    grid: {
      top: '3%',
      right: '5%',
      width: '95%',
      bottom: 30,
      containLabel: true,
    },
    color: lineColorSet,
    xAxis: {
      type: 'category',
      data: xAxis,
      axisTick: {
        alignWithLabel: true, // x轴刻度线与标签对齐
        lineStyle: {
          color: '#BFBFBF',
          width: 1,
        }
      },
      boundaryGap: true,
      axisLabel: {
        // formatter: lineFormatterXAxis,
        // x轴文字样式
        color: '#000',
        align: 'center',
        opacity: 0.45,
        fontSize: 12,
        margin: 10,
      },
      axisLine: {
        show: true,
        onZero: false,// 当y轴有负数时,让x轴下落在y轴最小值
        lineStyle: {
          color: '#BFBFBF',
          width: 1,
        }
      },
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      },
      axisLabel: {
        formatter(value) {
          return formatNum(value);
        },
      },
    },
    series: [
      {
        name: formatMessage({ id: 'dbi_mobile_games' }),
        type: 'line',
        symbol: 'circle',
        symbolSize: 6,
        showSymbol: false,
        areaStyle: {
          opacity: 0.4,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#F2F3F5' },
            { offset: 0, color: lineColorSet[0] }
          ])
        },
        data: mobileData,
        tooltip: {
          valueFormatter(value) {
            return formatNum(value);
          },
          backgroundColor: 'rgba(0,0,0,0)'
        }
      },
      {
        name: formatMessage({ id: 'dbi_pc_games' }),
        type: 'line',
        symbol: 'circle',
        symbolSize: 6,
        showSymbol: false,
        areaStyle: {
          opacity: 0.4,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#F2F3F5' },
            { offset: 0, color: lineColorSet[1] }
          ])
        },
        data: pcData,
        tooltip: {
          valueFormatter(value) {
            return formatNum(value);
          },
          backgroundColor: 'rgba(0,0,0,0)'
        }
      },
      {
        symbol: 'circle',
        symbolSize: 6,
        showSymbol: false,
        name: formatMessage({ id: 'dbi_console_games' }),
        type: 'line',
        areaStyle: {
          opacity: 0.4,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#F2F3F5' },
            { offset: 0, color: lineColorSet[2] }
          ])
        },
        data: consoleData,
        tooltip: {
          valueFormatter(value) {
            return formatNum(value);
          },
          backgroundColor: 'rgba(0,0,0,0)'
        }
      },
    ],
  })

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let myChart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      myChart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      myChart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(myChart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (myChart && listener !== null) {
        window.removeEventListener('resize', listener);
        myChart.off();
      }
    };
  }, [props]);

  return (
    <div style={{ ...chartStyle }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );
}
